module.exports = __webpack_public_path__ + "img/error.f9926f55.png";